'use client'

import { Icon } from '@/components'
import { INTERNAL_DATA, SOCIAL_LINKS } from '@/config/global-config'
import Link from '@/features/ref/components/Link'
import { Box, Divider, Stack, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import NextImage from 'next/image'
import { useEffect } from 'react'
import dynamic from 'next/dynamic'
const FacebookFanpageEmbed = dynamic(() => import('./facebook-fanpage'), { ssr: false })
export const SOCIAL_LINKS_BOTTOM = [
  // { Icon: Icon.Shopee, link: SOCIAL_LINKS.shoppe, alt: 'shopee' },
  // { Icon: Icon.Lazada, link: SOCIAL_LINKS.lazada, alt: 'lazada' },
  { Icon: Icon.TikTok, link: SOCIAL_LINKS.tiktok, alt: 'tiktok' },
  { Icon: Icon.Facebook, link: SOCIAL_LINKS.facebook, alt: 'facebook' },
  { Icon: Icon.Youtube, link: SOCIAL_LINKS.youtube, alt: 'youtube' },
  { Icon: Icon.Zalo, link: SOCIAL_LINKS.zalo, alt: 'zalo' },
]

export const LeftSide = () => {
  const t = useTranslations()

  // Parse lại Facebook widget sau khi component mount
  useEffect(() => {
    // Đợi Facebook SDK load xong
    const timer = setTimeout(() => {
      if (window.FB) {
        window.FB.XFBML.parse()
      }
    }, 1000)

    return () => clearTimeout(timer)
  }, [])

  return (
    <Stack spacing={2} sx={{ height: '100%' }}>
      <Box
        sx={{
          // height: { md: '76px', xs: '62px', xl: '96px' },
          width: 'auto',
          display: 'flex',
          '.dark &': {
            filter: 'invert(1)',
          },
          gap: 1,
          alignItems: { md: 'flex-start', xs: 'center' },
          flexDirection: 'column',
        }}
      >
        <Link href="/" style={{ height: '100%', width: '100%', maxWidth: '240px', display: 'block' }}>
          <NextImage
            height={88}
            width={240}
            quality={90}
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            src={INTERNAL_DATA.logo}
            alt="MONA Shop"
            style={{ height: '100%', width: '100%' }}
          />
        </Link>
        <Divider sx={{ width: '100%', height: '1px', bg: '#BBBBBA' }} />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Typography variant="caption" color="primary.main" sx={{ fontSize: '0.875rem', fontWeight: 600 }}>
            CÔNG TY TNHH HYDRA STUDIO
          </Typography>
          <Typography variant="caption" color="primary.main" sx={{ fontSize: '0.875rem', fontWeight: 100 }}>
            Mã số doanh nghiệp: 0319279370
          </Typography>
        </Box>
        <Divider sx={{ width: '100%', height: '1px', bg: '#BBBBBA' }} />
      </Box>
      <Stack spacing={0.5}>
        <Typography variant="caption" color="primary.main" sx={{ fontSize: '0.875rem', fontWeight: 600 }}>
          {t('Footer.social.title')}:
        </Typography>
        <Stack>
          {SOCIAL_LINKS_BOTTOM.map((Item) => (
            <Link
              style={{ width: '100%' }}
              href={Item.link}
              target="_blank"
              key={Item.link}
              rel="noopener noreferrer nofollow"
            >
              <Box
                component={'span'}
                sx={{
                  display: 'flex',
                  sx: { xs: '10px', md: '12px' },
                  alignItems: 'center',
                  justifyContent: 'flex-center',
                  gap: '0.5rem',
                  p: '0.875rem 0',
                  width: '100%',
                  color: 'primary.main',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    color: 'primary.contrastText',
                    backgroundColor: 'primary.main',
                    p: '0.875rem',
                  },
                }}
              >
                <Item.Icon sx={{ fontSize: { xs: '12px', md: '14px', color: 'inherit' } }} />
                <Typography
                  textTransform={'uppercase'}
                  variant="caption"
                  sx={{ fontSize: '0.875rem', flex: 1, color: 'inherit', lineHeight: '1.3' }}
                >
                  {Item.alt}
                </Typography>
                <Icon.Blank sx={{ fontSize: { xs: '10px', md: '12px', color: 'inherit' } }} />
              </Box>
            </Link>
          ))}
          <Divider sx={{ width: '100%', height: '1px', bg: '#BBBBBA' }} />
        </Stack>
      </Stack>

      {/* <Stack spacing={0.5}>
        <Typography variant="caption" color="primary.main" sx={{ fontSize: '0.875rem', fontWeight: 600 }}>
          {t('Footer.social.title')}:
        </Typography>
        <Stack direction={'row'} spacing={1}>
          {SOCIAL_LINKS_TOP.map((Item) => (
            <Link href={Item.link} target="_blank" key={Item.link}>
              <Item.Icon
                sx={{
                  fontSize: { xs: '1.25rem', md: '2rem' },
                  color: 'primary.main',
                  transition: 'all 0.3s ease',
                  '&:hover': { transform: 'translateY(-2px)' },
                }}
              />
            </Link>
          ))}
        </Stack>
      </Stack> */}
      <Box sx={{ width: '100%' }}>
        <FacebookFanpageEmbed />
      </Box>
    </Stack>
  )
}
